import React from 'react'
import { useState } from 'react';
import './OurIndustryService.css'
import I1 from "../../img/oil&gas.jpg";
import I2 from "../../img/realEstat.jpg";
import I3 from "../../img/EcommerceI.jpg";
import I4 from "../../img/Logistic-I.jpg";
import I5 from "../../img/Fintech-I.jpg";




export default function OurIndustryindustry() {
    const [emailInput, setEmailInput] = useState("");
      const [mobileInput, setMobileInput] = useState("");
    
      const [isEmailTouched, setIsEmailTouched] = useState(false);
      const [isMobileTouched, setIsMobileTouched] = useState(false);
    
      const [isEmailValid, setIsEmailValid] = useState(true);
      const [isMobileValid, setIsMobileValid] = useState(true);
    
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const mobileRegex = /^[0-9]{10}$/;
    
      const onEmailChangeHandler = (event) => {
        const value = event.target.value;
        setEmailInput(value);
        setIsEmailTouched(true);
        setIsEmailValid(value.length > 0 && emailRegex.test(value));
      };
    
      const onMobileChangeHandler = (event) => {
        const value = event.target.value;
        setMobileInput(value);
        setIsMobileTouched(true);
        setIsMobileValid(value.length > 0 && mobileRegex.test(value));
      };
    
      const submitHandler = (event) => {
        event.preventDefault();
    
        if (emailInput.trim().length === 0) setIsEmailValid(false);
        if (mobileInput.trim().length === 0) setIsMobileValid(false);
    
        if (isEmailValid && isMobileValid) {
          alert("Form Submitted Successfully!");
          setEmailInput("");
          setMobileInput("");
          setIsEmailTouched(false);
          setIsMobileTouched(false);
        }
      };
  return (
    <div>
      <div className="our-industry-page">
      {/* Top Heading */}
      <header className="top-header">
        <h1>OUR SERVICES</h1>
        <p>Tailored to you — we create custom software specifically designed to meet your unique business needs.</p>
      </header>
      <hr className="our-industry-hr"/>

      <div className="our-industry-container">
        {/* Left Side - Fixed Content */}
        <div className="left-side">
          <h2>Order a free consultation - Our experts will select the most effective solution</h2>
          <p></p>
          <form onSubmit={submitHandler}>
            <div className="form-control">
              
              <input
                type="email"
                id="email"
                placeholder="Email*"
                value={emailInput}
                onChange={onEmailChangeHandler}
                onBlur={() => setIsEmailTouched(true)}
              />
              {!isEmailValid && isEmailTouched && emailInput.length === 0 && (
                <p className="error-text">*Email is required</p>
              )}
              {!isEmailValid && isEmailTouched && emailInput.length > 0 && (
                <p className="error-text">*Please enter a valid email</p>
              )}
            </div>

            <div className="form-control">
             
              <input
                type="text"
                id="mobile"
                placeholder="Mobile Number*"
                value={mobileInput}
                onChange={onMobileChangeHandler}
                onBlur={() => setIsMobileTouched(true)}
              />
              {!isMobileValid && isMobileTouched && mobileInput.length === 0 && (
                <p className="error-text">*Mobile number is required</p>
              )}
              {!isMobileValid && isMobileTouched && mobileInput.length > 0 && (
                <p className="error-text">*Please enter a valid 10-digit mobile number</p>
              )}
            </div>

        <div className="form-actions">
          <button type="submit" >
            Order Consultation
          </button>
        </div>
      </form>
        </div>
        <div className="vertical-line-industry"></div>

        {/* Right Side - Scrollable Content */}
        <div className="right-side-industry">
          {/* First industry */}
          <div className="industry-right-flex">
          <div className="our-industry-section">
            <div className="id-industry">01/</div>
            <h3>Oil & Gas</h3>
            <p className="industry-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions.
            </p>
            <div className="tags-Industry">
            <span>LOGISTICS SOFTWARE</span>

<span>BILLING & ACCOUNTING SYSTEMS</span>
              
            </div>
          </div>
          <div className="img-industry-container">
           <img src={I1} alt="" />
          </div>
          </div>
          <hr className="right-line-industry"/>

          {/* Second industry */}
          <div className="industry-right-flex">
          <div className="our-industry-section">
            <div className="id-industry">02/</div>
            <h3>Real Estate</h3>
            <p className="industry-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions.
            </p>
            <div className="tags-Industry">
           
<span>REAL E-COMMERCE</span>

<span>MOBILE APP CALCULATOR</span>

<span>CATALOGS FOR REALTORS</span>
              
            </div>
          </div>
          <div className="img-industry-container">
           <img src={I2} alt="" />
          </div>
          </div>
          <hr className="right-line-industry"/>


          {/* Third industry */}
          <div className="industry-right-flex">
          <div className="our-industry-section">
            <div className="id-industry">03/</div>
            <h3>Ecommerce</h3>
            <p className="industry-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions.
            </p>
            <div className="tags-Industry">
            
<span>SAAS</span>

<span>INTERNET SHOPS</span>

<span>CORPORATE WEBSITES</span>

<span>MARKETPLACES</span>
              
            </div>
          </div>
          <div className="img-industry-container">
           <img src={I3} alt="" />
          </div>
          </div>
          <hr className="right-line-industry"/>


          {/* Fourth industry */}
          <div className="industry-right-flex">
          <div className="our-industry-section">
            <div className="id-industry">04/</div>
            <h3>Logistics</h3>
            <p className="industry-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions.
            </p>
            <div className="tags-Industry">
            <span>TRANSPORTATION MANAGEMENT SYSTEM</span>
            <span>SHIPMENT MANAGEMENT</span>
            <span>FREIGHT MANAGEMENT

</span>
            <span>ROUTE PLANNING</span>

            </div>
          </div>
          <div className="img-industry-container">
           <img src={I4} alt="" />
          </div>
          </div>
          <hr className="right-line-industry"/>
          <div className="industry-right-flex">
          <div className="our-industry-section">
            <div className="id-industry">05/</div>
            <h3>Fintech</h3>
            <p className="industry-p">
            Our Evaluation & Design process serves as a solid foundation for the successful development and deployment of custom software solutions.
            </p>
            <div className="tags-Industry">
           <span>DIGITAL BANKING</span>
           <span>WEALTH MANAGEMENT</span>
           <span>MARKETPLACE LENDING</span>
           <span>PERSONAL BANKING</span>
           <span>
           PAYMENTS MANAGEMENT</span>
              
            </div>
          </div>
          <div className="img-industry-container">
           <img src={I5} alt="" />
          </div>
          </div>
        

          
        </div>
      </div>
    </div>
    </div>
  )
}
